@let portalOrder = portalOrder$ | async; @let state = stateService.getState();
@if (portalOrder) {
  <stepper
    [step]="Steps.ProtectionPlans"
    [isChangeMode]="portalOrder.isChange"
    [ancillaryUpsell]="ancillaryUpsell"
  />

  <div class="d-flex flex-column flex-md-row p-4 p-md-0 py-md-6">
    <div class="d-flex flex-column flex-1">
      <h2 class="semi-bold" data-id="sold-amount-per-adult">
        Avoid paying out of pocket if your
        {{ portalOrder.soldAmountPerAdult | portalCurrency }} trip is disrupted
      </h2>

      <p class="mt-2" data-id="protected-sold-amount-per-adult">
        With Premium Disruption Assistance, we handle airline disruptions for you — with up to
        {{ portalOrder.soldAmountPerAdult + coverage | portalCurrency }} in rebooking coverage
      </p>

      <ds-card class="d-flex flex-column p-4 p-md-6 mt-4 card">
        <div class="d-flex align-items-center">
          <img
            src="/assets/images/3d-shield-white.webp"
            alt="3d-shield-white"
            width="120"
            height="120"
          />

          <div class="d-flex flex-column ml-md-6">
            <most-popupar-badge />

            <h2 class="semi-bold mt-3">Premium Disruption Assistance</h2>

            @let price =
              state.cancelForAnyReason || state.bundle
                ? pricePerTraveler
                : priceWithoutDiscountPerTraveler;

            <p class="semi-bold mt-1" data-id="price-per-traveler">
              {{ price | portalCurrency }} per person
            </p>
          </div>
        </div>

        <hr class="my-6" />

        <div class="d-flex flex-column g-6 flex-md-row">
          @for (section of sections; track section) {
            <div class="d-flex flex-1 flex-column g-3">
              <p class="semi-bold">{{ section.title }}</p>

              @for (item of section.items; track item) {
                <div class="item">
                  <img
                    src="/assets/icons/{{ item.icon }}.svg"
                    alt="{{ item.icon }}"
                    width="20"
                    height="20"
                  />

                  <p class="semi-bold">{{ item.label }}</p>

                  <p>&nbsp;</p>

                  <p>{{ item.details }}</p>
                </div>
              }
            </div>
          }
        </div>
      </ds-card>

      <div class="d-none d-md-flex flex-md-row-reverse g-2 mt-6">
        <ng-container *ngTemplateOutlet="actionsTemplate" />
      </div>
    </div>

    <div class="d-flex flex-column g-6 mt-8 mt-md-0 ml-md-5">
      <price-summary
        [option]="portalOrder"
        [disruptionProtection]="state.disruptionProtection"
        [tipsAmount]="state.tipsAmount"
        [bundle]="state.bundle"
        [cancelForAnyReason]="state.cancelForAnyReason"
        [promocodeDiscountAmount]="state.promocodeDiscountAmount"
      />

      <client-review
        [data]="{
          summary: 'Fantastic Service for Business Travelers',
          review:
            'I have been using Business Class Consolidators for three years already for my business travel. At times my trips are complicated, with multiple stops and sometimes multiple airlines.  I continue to be impressed with their effectiveness and efficiency in getting flights booked.  Equally importantly, when I have had an issue with a flight being cancelled, BCC has stepped in and helped make another plan quickly.    They can also book flights so that I still get the value of my frequent flier status on the main carrier I use.  I can highly recommend BCC.',
          from: 'Catherine Crowley',
          img: '/assets/images/client_c.webp',
          details: 'Jun 30, 2025',
        }"
        class="review"
      />
    </div>

    <div class="d-flex flex-column g-2 mt-8 d-md-none">
      <ng-container *ngTemplateOutlet="actionsTemplate" />
    </div>
  </div>
}

<ng-template #actionsTemplate>
  <ds-button (click)="continue()" data-id="continue" label="Continue with protection" />

  <ds-button
    (click)="next()"
    variant="secondary"
    class="ml-md-auto"
    data-id="no"
    label="Continue without protection"
  />

  <ds-button
    (click)="back()"
    variant="secondary"
    leadingIcon="chevronLeft"
    data-id="back"
    label="Back"
  />
</ng-template>

<ng-template #askToSignInTemplate>
  <ask-to-sign-in-modal
    (hideModal)="hideAskToSignInModal()"
    (continueAsGuest)="continueAsGuestFromSignInPrompt()"
    (showSignInModal)="showSignInModal()"
  />
</ng-template>
